<div class="animated fadeInRight">
    <!-- MENU DE TITULOS -->
    <app-lfsa-card-v2
      [titulo]      = "DAT_TITULOS.titulo"
      [modulo]      = "DAT_TITULOS.modulo"
      [tituloCard]  = "DAT_TITULOS.tituloCardList"
      [innTemplate] = "enviarTemplateEdit"
      [innTemplateButton]="innTemplateButton">
    </app-lfsa-card-v2>
    <!-- MENU DE TITULOS -->
    
    <!-- OPCIONES BOTONES IZQUIERDO -->
    <ng-template #innTemplateButton >
      <div class="col-md-6 mb-2" *ngIf="!isAsignar">
        <div class="pagetitle">
          <div class="btn-group-justified btn-group" style="float: right;">
            <button (click)="nuevo()" class="btn btn-outline-success"> 
              <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>
          </div>
        </div>
      </div>
      
      <app-lfsa-card *ngIf="isAsignar"
        [innTemplate]="clasificacion" [titulo]="'Agregar Clasificacion Nivel 3'" 
        [banderaColapse]="false" [efecto]="true">
      </app-lfsa-card>
    </ng-template>
    <!-- OPCIONES BOTONES IZQUIERDO --> 
    
    <!-- PANTALLA DE ASIGNACIONES -->     
    <ng-template #clasificacion>
      <div class="container-fluid">     
        <form [formGroup]="formDetalle" class="form-group" novalidate>
          <div class="row align-items-center">
            <div class="col">
              <app-lfsa-combo-box [label]="'Unidad Negocio'" formControlName="unidadNegocio" [control]="formDetalle.get('unidadNegocio')" 
                                  [comboBox]="comboUnegocio" [opcion]="'descCorta'" [idOpcion]="'idUnidad'" [habilitar]="isAsignar">
              </app-lfsa-combo-box>
            </div>
            <div class="col">
              <app-lfsa-combo-box [label]="'* Canal'" formControlName="canal" [control]="formDetalle.get('canal')" 
                                  [comboBox]="comboCanal" [opcion]="'descCorta'" [idOpcion]="'idCanal'" [habilitar]="isAsignar">
              </app-lfsa-combo-box>
            </div>
            <div class="col">
              <app-lfsa-combo-box [label]="'* Sub-Canal'" formControlName="subCanal" [control]="formDetalle.get('subCanal')" 
                                  [comboBox]="comboSubCanal" [opcion]="'dscaGrupoCanal'" [idOpcion]="'idTarCanal'" [habilitar]="isAsignar">
              </app-lfsa-combo-box>
            </div>
            <div class="col">
              <app-lfsa-combo-box [label]="'* Grupo Cliente'" formControlName="grupoPrecios" [control]="formDetalle.get('grupoPrecios')" 
                                  [comboBox]="comboGPrecios" [opcion]="'dscaGrupoCliente'" [idOpcion]="'idGrupoCliente'">
              </app-lfsa-combo-box>
            </div>
            <div class="col">              
              <button (click)="agregarDetalle()" class="btn btn-success"> <i aria-hidden="true" class="fa fa-plus"></i> Agregar </button>
              <button (click)="returnNivel_1()" class="btn btn-danger"> <i aria-hidden="true" class="fa fa-caret-left"></i> Regresar </button>
            </div>
          </div> 
        </form>
      </div>
    </ng-template>
    <!-- PANTALLA DE ASIGNACIONES -->
    
    <!-- GRILLA -->
    <ng-template #enviarTemplateEdit> 
      <app-lfsa-loading-v2 *ngIf="loading"></app-lfsa-loading-v2>
      <ag-grid-angular #agGrid (gridReady)="onGridReady($event)"  
                        [id]    ="DAT_AG_GRID.id" 
                        [class] ="DAT_AG_GRID.class" 
                        [ngStyle]="DAT_AG_GRID.style" 
                        [rowData]="rowData" 
                        [columnDefs]="columnDefs"
                        [pagination]="DAT_AG_GRID.pagination" 
                        [paginationPageSize]="DAT_AG_GRID.pagina"
                        [allowContextMenuWithControlKey]="true"
                        [frameworkComponents]="frameworkComponents" >
      </ag-grid-angular>
    </ng-template>
    <!-- GRILLA -->

  </div>
  
  <!-- MODAL DE CREACIÓN DE JERARQUIA Y SUBCANAL-->
  <app-lfsa-modal [innTemplate] = "abrirModal" [classModal] = "'modal-lg'" [idButton] = "'abrirModal'" [idClose] = "'cerrarModal'" [titulo] = "titleModal">
  </app-lfsa-modal>
  
  <ng-template #abrirModal>
    <div class="container-fluid">
      <form [formGroup]="formulario" mat-dialog-content>
        <div class="row"> 
          <div class="col">
            <app-lfsa-input formControlName="nivel" [label]="'* Nivel '" [id]="'nivel'" [control]="formulario.get('nivel')" [type]="'number'" [isReadOnly]="true">
            </app-lfsa-input>
          </div>

          <div class="col">
            <app-lfsa-combo-box [label]="'* Seleccione Unidad Negocio'" formControlName="unidadNegocio" [control]="formulario.get('unidadNegocio')" 
                                [comboBox]="comboUnegocio" [opcion]="'descCorta'" [idOpcion]="'idUnidad'" [habilitar]="!isCreate">
            </app-lfsa-combo-box>
          </div>
          <div class="col">
            <app-lfsa-combo-box [label]="'* Seleccione Canal'" formControlName="canal" [control]="formulario.get('canal')" 
                                [comboBox]="comboCanal" [opcion]="'descCorta'" [idOpcion]="'idCanal'" [habilitar]="!isCreate">
            </app-lfsa-combo-box>
          </div>

          <div class="col" *ngIf="!isCreate">
            <app-lfsa-combo-box [label]="'* Seleccione subCanal'" formControlName="subCanal" [control]="formDetalle.get('subCanal')" 
                                [comboBox]="comboSubCanal" [opcion]="'dscaGrupoCanal'" [idOpcion]="'idTarCanal'">
            </app-lfsa-combo-box>
          </div>

        </div>

        <app-lfsa-botones-formulario 
            (devolverAccion) ="acciones( $event )" 
            [formularioValido] ="formulario.invalid" 
            [loading]="loading" [textBoton]="'Guardar'" class="row p-3">
        </app-lfsa-botones-formulario>
      </form>
    </div>
  </ng-template>
  <!-- END MODAL CREACION DE JERARQUIA--> 